import _get from 'lodash/get';

const formatIngredient = ingredient => ({
  id: ingredient.id,
  type: ingredient.type,
  count: ingredient.count,
});

const getGoodData = good => {
  const goodId = _get(good, 'id');
  const includeIngredients = _get(good, 'include_ingredients', []);
  const addedIngredients = _get(good, 'added_ingredients', []).map(formatIngredient);
  const addedSauces = _get(good, 'added_sauces', []);
  const removedIngredients = _get(good, 'removed_ingredients', []).map(formatIngredient);
  const removedIngredientIds = new Set(removedIngredients.map(ingredient => String(ingredient.id)));
  const manuallyRemovedIngredients = includeIngredients
    .filter(ingredient => ingredient.removed && !removedIngredientIds.has(String(ingredient.id)))
    .map(ingredient => ({ id: ingredient.id, count: 0 }));

  return {
    good_id: goodId,
    ingredients: [...addedIngredients, ...removedIngredients, ...manuallyRemovedIngredients],
    sauces: addedSauces.length > 0 ? addedSauces.map(sauce => sauce.id) : undefined,
  };
};

export const preSaveFormatComposition = composition => {
  const filtedComposition = composition.filter(
    ({ type }) =>
      type === 'good' ||
      type === 'combo' ||
      type === 'promotional' ||
      type === 'bonus' ||
      type === 'upsale',
  );

  return filtedComposition.map(good => {
    const { item, ...otherProps } = good;

    if (good.type !== 'combo') {
      return {
        ...getGoodData(item),
        ...otherProps,
      };
    }

    const comboBoxItems = item.combo_box_items.map(comboBoxItem => {
      return {
        ...getGoodData(comboBoxItem),
        level_id: comboBoxItem.level_id,
        price: comboBoxItem.price,
        discount_price: comboBoxItem.discount_price,
        count: comboBoxItem.count,
        type: 'good',
      };
    });

    return {
      combo_box_id: good.item.combo_box_id,
      combo_box_items: comboBoxItems,
      ...otherProps,
    };
  });
};
